export enum Core {
  KEY_PREFIX = 'nj',
  DATA_API_KEY = '.data-api'
}
